"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MakeFilterView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/views/MakeFilterView"));
const ListingBannerView = ({ filteredMakeModel, isMergedOffer, makeFilterFormData, handleFilterChange, }) => react_1.default.createElement("div", { className: "subscription-listing-banner" },
    react_1.default.createElement("h1", { className: "title" }, `Operativní leasing ${filteredMakeModel}`),
    isMergedOffer === false
        && react_1.default.createElement(MakeFilterView_1.default, { makeFilterFormData: makeFilterFormData, handleFilterChange: handleFilterChange }));
exports.default = ListingBannerView;
